// src/pages/Overview/components/OperatorGreeting.tsx

import { Typography } from '@mui/material'
import { useEffect, useState } from 'react'

import { SalutationMode } from '@/types/karma/operator'

import { OperatorData, useAppConfig, useOperator } from '../../../hooks'

export const OperatorGreeting = () => {
  const opData: OperatorData = useOperator()

  const { daytimeGreeting, appConfig } = useAppConfig()

  const mode: SalutationMode = appConfig.salutationMode

  const [salutation, setSalutation] = useState<string>('')

  useEffect(() => {
    if (!opData) return

    const setMode = () => {
      const { first_name, last_name } = opData

      const salutation: string =
        mode === 'default'
          ? `${first_name} ${last_name}`
          : mode === 'short'
            ? first_name
            : ''

      setSalutation(salutation)
    }
    setMode()
  }, [opData, mode])

  return mode === 'noSalutation' ? null : (
    <Typography sx={{ textAlign: 'center', p: 5 }} variant={'h4'}>
      {daytimeGreeting()}, {salutation}!
    </Typography>
  )
}
